import React, {Component} from 'react';
import FancyButton from '../widgets/FancyButton';
import './ProfileHelpPanel.css';
import FancyLink from '../widgets/FancyLink';

class ProfileHelpPanel extends Component {
	constructor() {
		super();

		this.state = {
			userClosed: false
		};

		this.close = () => this.setState({userClosed: true});
	}

	render() {
		return (
			<div className={`ProfileHelpPanel ${this.state.userClosed ? 'hidden' : 'shown'}`}>
				<div className="ProfileHelpPanel-message">
					<span className="icon icon-info" />
					<p>
						Welcome to your profile! Need help? Please feel free to get in{' '}
						<a
							href="https://b2me.zendesk.com/hc/en-us/requests/new"
							target="_blank"
							rel="noopener noreferrer">
							contact with us
						</a>
						.
					</p>
				</div>
				<div className="ProfileHelpPanel-actions">
					<FancyLink
						onClick={this.close}
						className="emphasis"
						href="https://b2me.zendesk.com/hc/en-us/requests/new"
						target="_blank"
						rel="noopener noreferrer">
						Yes, please
					</FancyLink>
					<FancyButton onClick={this.close}>No, thanks</FancyButton>
				</div>
			</div>
		);
	}
}

export default ProfileHelpPanel;



// WEBPACK FOOTER //
// ./src/profile/ProfileHelpPanel.js